module.exports = __webpack_public_path__ + "static/flux-sketch-2-c8aab11fad0864c844822a775235112e.jpg";